var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('h1',{staticClass:"text-md-center green-security"},[_vm._v(_vm._s(_vm.menu.title))]),(_vm.menu.menus_dropdown.length)?_c('drop-down-list',{attrs:{"menus":_vm.menu.menus_dropdown}}):_vm._e(),(_vm.menu.menus.length)?_c('internal-menus-list',{attrs:{"menus":_vm.menu.menus,"title":_vm.menu.title}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }